"use client";

import dynamic from "next/dynamic";
import type { V3LiveAllInProps } from "./v3-live-all-in.client";

/**
 * `V3LiveAllIn`, in a chunk of its own — the second half of the split
 * `zip-code-lazy.client.tsx` starts, for the same reason.
 *
 * ⚠ THE ZIP CODE'S UI IS NOT THE ONLY DOOR INTO `services/zip`. This leaf calls
 * `useZipStore`, which reaches the whole data layer by a different path than the
 * molecule. Imported straight from `fill-plan-slots.tsx` — reached from a SERVER Component,
 * where `next/dynamic` does not split a client one — that tree landed in the shared
 * entry chunk for `app/v3/[...slug]`. Lazily loading the ZIP Code alone closed one
 * door and left this one open.
 *
 * No `ssr: false`: the server already painted every all-in at the default ZIP's fee,
 * and that copy is what the visitor reads until a ZIP is committed.
 */
export const V3LiveAllInLazy = dynamic<V3LiveAllInProps>(
  () => import("./v3-live-all-in.client").then(m => m.V3LiveAllIn)
);

export default V3LiveAllInLazy;
